import React from "react";
import { createRoot } from "react-dom/client";

import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";

import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import "./custom.scss";
import { getMsalConfiguration } from "./app/helpers/environmentHelper";

const container = document.getElementById("root")!;
const root = createRoot(container);

let configuration: Configuration = getMsalConfiguration(window.location.hostname).configuration;

export const msalInstance = new PublicClientApplication(configuration);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Provider>
  </React.StrictMode>
);